import { useEffect, useState } from "react";
import { getGasConsumptionData } from "../../../Rest_api/RestApi";
import { GasConsumptionData } from "../../../models/gas";
import {
  ChartDataParams,
  FormatChartData,
  FormatChartDataWithAverages,
} from "../../../components/recharts/functions";
import { ReMixChart } from "../../../components/recharts/ReMixCharts";
import { ChartType } from "../../../models/chart_model";
import { ExchangeColors } from "../Exchange3/FormatData";
import { renderQuarterTick } from "../../../components/recharts/components";
import FilterMenu from "../../../components/FilterMenu";
import {
  getFiscalYear,
  GetNumberOfDaysInMonth,
  getQuarter,
} from "../../../extensions/date";
import {
  CHART_TYPES,
  GAS_BAR_GAP,
  getAvailableMonths,
  getGasColors,
  INTERVALS,
} from "./Gas_Const";
import {
  stringToColor,
  stringToConsistentColor,
} from "../../../extensions/string";
import { Group_keys } from "../../Dmrc/Data";
import { SearchBox } from "../../../components/Search";

const GROUP_BY = [
  { key: "sector__sector_name", label: "Sector" },
  { key: "consumption", label: "Consumption Type" },
];
const keys = [
  {
    key: "month",
    label: "Month",
  },
];

const CONSUMPTION = [
  { value: "domestic_consumption_mmscmd", label: "Domestic Consumption" },
  { value: "rlng_consumption_mmscmd", label: "RLNG Consumption" },
  { value: "total_consumption_mmscmd", label: "Total Consumption" },
];
const CONSUMPTION_TABS = [
  { value: [CONSUMPTION[2]], label: "Total Consumption" },
  {
    value: [CONSUMPTION[0], CONSUMPTION[1]],
    label: "Domestic & RLNG Consumption",
  },
];
export function Consumption() {
  const [consumptionData, setConsumptionData] = useState<GasConsumptionData[]>([]);
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);
  const [chartKeys, setChartKeys] = useState({
    keys: [] as string[],
    label: [] as string[],
  });
  const [selectedChartType, setSelectedChartType] = useState(CHART_TYPES[1]);
  const [selectedConsumptionTab, setSelectedConsumptionTab] = useState(
    CONSUMPTION_TABS[1]
  );
  const [availableMonths, setAvailableMonths] = useState<any[]>([]);
  const [selectedGroupKeys, setSelectedGroupKeys] = useState<any[]>([
    GROUP_BY[1],
  ]);
  const [selectedKeys, setSelectedKeys] = useState<any[]>(keys);
  const [selectedMonthYear, setSelectedMonthYear] = useState<any[]>([]);

  const [selctedConsumption, setSelectedConsumption] = useState([
    CONSUMPTION[0],
    CONSUMPTION[1],
  ]);
  const [selectedSector, setselectedSector] = useState<any[]>([]);
  const [selectedSectorType, setselectedSectorType] = useState<any[]>([]);
  useEffect(() => {
    _handlefetchData();
  }, []);
  async function _handlefetchData() {
    const newData = await getGasConsumptionData({});
    setConsumptionData(newData);
    setAvailableMonths(getAvailableMonths(newData));
    // setAvailableMonths(
    //   getAvailableMonths(newData));
  }
  useEffect(() => {
    let filteredData = consumptionData;
    if (selectedSector.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedSector.includes(item.sector__sector_name)
      );
    }

    if (selectedSectorType.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedSectorType.includes(item.sector__sector_type__sector_type)
      );
    }
    if (selectedMonthYear.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedMonthYear.map((item) => item.label).includes(item.month_year)
      );
    }
    if (selectedKeys.length == 1) {
      const unique_month_year = filteredData
        .map((item) => item.month_year)
        .filter((value, index, self) => self.indexOf(value) === index);
      if (selectedKeys[0].key == "year") {
        filteredData = filteredData.map((item) => {
          const numberOfDays = GetNumberOfDaysInMonth(item.month, item.year);
          const monthsInYear = unique_month_year.filter((month_year) =>
            month_year.includes(item.year.toString())
          ).length;
          return {
            ...item,
            domestic_consumption_mmscmd:
              item.domestic_consumption_mmscmd / monthsInYear,
            rlng_consumption_mmscmd:
              item.rlng_consumption_mmscmd / monthsInYear,
            total_consumption_mmscmd:
              item.total_consumption_mmscmd / monthsInYear,
          };
        });
      } else if (selectedKeys[0].key == "month") {
        filteredData = filteredData.map((item) => {
          const number_of_month = unique_month_year.filter((month_year) =>
            month_year.includes(item.month)
          ).length;
          return {
            ...item,
            domestic_consumption_mmscmd:
              item.domestic_consumption_mmscmd /*/ number_of_month */,
            rlng_consumption_mmscmd:
              item.rlng_consumption_mmscmd /*/ number_of_month */,
            total_consumption_mmscmd:
              item.total_consumption_mmscmd /*/ number_of_month */,
          };
        });
      } else if (selectedKeys[0].key == "fyear") {
        const unique_month_fyear = filteredData
          .map((item) => item.month_fyear)
          .filter((value, index, self) => self.indexOf(value) === index);
        filteredData = filteredData.map((item) => {
          // const numberOfDays = GetNumberOfDaysInMonth(item.month, item.year);
          const monthsInYear = unique_month_fyear.filter((month_year) =>
            month_year.includes(item.fyear.toString())
          ).length;
          return {
            ...item,
            domestic_consumption_mmscmd:
              item.domestic_consumption_mmscmd / monthsInYear,
            rlng_consumption_mmscmd:
              item.rlng_consumption_mmscmd / monthsInYear,
            total_consumption_mmscmd:
              item.total_consumption_mmscmd / monthsInYear,
          };
        });
      } else if (selectedKeys[0].key == "quarter") {
        const unique_month_quarter = filteredData
          .map((item) => item.month_quarter)
          .filter((value, index, self) => self.indexOf(value) === index);
        filteredData = filteredData.map((item) => {
          const monthsInYear = unique_month_quarter.filter((month_year) =>
            month_year.includes(item.quarter.toString())
          ).length;
          return {
            ...item,
            domestic_consumption_mmscmd:
              item.domestic_consumption_mmscmd / monthsInYear,
            rlng_consumption_mmscmd:
              item.rlng_consumption_mmscmd / monthsInYear,
            total_consumption_mmscmd:
              item.total_consumption_mmscmd / monthsInYear,
          };
        });
      }
    }

    const par: ChartDataParams = {
      keys: selectedKeys.map((item) => item.key),
      groupBy: selectedGroupKeys.map((item) => item.key),
      volumeKey: "domestic_consumption_mmscmd",
      priceKey: "",
      aggregationKeys: ["rlng_consumption_mmscmd", "total_consumption_mmscmd"],
      data: filteredData,
    };
    const data = FormatChartData(par);
    console.log(data);

    setChartData(data.data);
    // setChartKeys(data.keys);
    setChartKeys({
      keys: data.keys,
      label: data.keysLabels,
    });
  }, [
    consumptionData,
    selectedGroupKeys,
    selectedKeys,
    selctedConsumption,
    selectedSector,
    selectedSectorType,
    selectedMonthYear,
  ]);

  function _handleGroupByChange(index: number) {
    setSelectedGroupKeys([GROUP_BY[index]]);
  }
  const handleKeySelection = (keyIndex: number) => {
    const selectedKey = INTERVALS[keyIndex]; // The key to be toggled
    setSelectedKeys([selectedKey]);
  };
  function _handleConsumptionSelection(index: number) {
    setSelectedConsumptionTab(CONSUMPTION_TABS[index]);
    setSelectedConsumption(CONSUMPTION_TABS[index].value);
  }
  function _handleSelectedSector(item: string) {
    const isSelected = selectedSector.find((value) => value === item);
    if (isSelected) {
      setselectedSector(selectedSector.filter((value) => value !== item));
    } else {
      setselectedSector((prev) => [...prev, item]);
    }
  }

  return (
    <div className="gas-page-container">
      <div className="side-filters-container text-nowrap">
        <FilterMenu
          title="Interval"
          items={INTERVALS.map((item) => item.label)}
          selectedItems={selectedKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            handleKeySelection(index);
          }}
        />
        <FilterMenu
          title="Consumption"
          items={CONSUMPTION_TABS.map((item) => {
            return item.label;
          })}
          selectedItems={[selectedConsumptionTab.label]}
          onSelect={(item, index) => {
            _handleConsumptionSelection(index);
          }}
        />

        <FilterMenu
          title="Group By"
          items={GROUP_BY.map((item) => item.label)}
          selectedItems={selectedGroupKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            _handleGroupByChange(index);
          }}
        />

        <FilterMenu
          title="Chart Type"
          items={CHART_TYPES.map((item) => item.label)}
          selectedItems={[selectedChartType.label]}
          onSelect={(item, index) => {
            setSelectedChartType(CHART_TYPES[index]);
          }}
        />

        {/* <FilterMenu
          title="Sector Type"
          items={consumptionData
            .map((item) => item.sector__sector_type__sector_type)
            .filter((value, index, self) => self.indexOf(value) === index)}
          selectedItems={selectedSectorType.map((item) => item)}
          onSelect={(item, index) => {
            _handleSelectedSectorType(item);
          }}
        /> */}
        <FilterMenu
          title="Sector"
          items={consumptionData
            .filter(
              (item) =>
                selectedSectorType.length == 0 ||
                selectedSectorType.includes(
                  item.sector__sector_type__sector_type
                )
            )
            .map((item) => item.sector__sector_name)
            .filter((value, index, self) => self.indexOf(value) === index)
            .sort()}
          selectedItems={selectedSector.map((item) => item)}
          onSelect={(item, index) => {
            _handleSelectedSector(item);
          }}
        />
      </div>
      <div className="gas-chart-container">
        <div className="gas-heading">
          <h2 className="chartHeading">
            {selectedConsumptionTab.label} (MMSCMD){" "}
            {selectedGroupKeys[0].label != GROUP_BY[1].label &&
              "by " + selectedGroupKeys[0].label}
          </h2>
          <SearchBox
            options={availableMonths}
            isMany={true}
            placeholder={
              availableMonths.length > 0
                ? `${availableMonths[0].label} to ${
                    availableMonths[availableMonths.length - 1].label
                  }`
                : "Select a date range"
            }
            selectedOptions={selectedMonthYear}
            onChange={(selected: any) => {
              setSelectedMonthYear(selected);
            }}
          />
        </div>
        <ReMixChart
          chartContainerHeight="100vh"
          data={chartData}
          barCategoryGap={GAS_BAR_GAP}
          xTick={true}
          // yAxisWidth={40}
          yAxisLabel="Volume (MMSCMD)"
          legends=//             type: ChartType.Line, //             name: key, //             dataKey: key+'_domestic_consumption', //         return { //     ...chartKeys.map((key, index) => { // [
          //             stroke: ExchangeColors[index],
          //             legendColor: ExchangeColors[index],

          //         }
          //     }).flat()
          // ]
          {[
            ...selctedConsumption
              .map((item, index1) => {
                return chartKeys.keys.map((key, index) => {
                  return {
                    dataKey: key + "_" + item.value,
                    stackId: selectedChartType.stackId,

                    name:
                      item.label.replace("Consumption", "") +
                      " " +
                      chartKeys.label[index],
                    type: selectedChartType.value,

                    stroke: getGasColors(
                      item.label + " " + chartKeys.label[index],
                      index + index1 * chartKeys.keys.length
                    ),
                  };
                });
              })
              .flat(),
          ]}
          xDataKey={selectedKeys[0].key}
          unit="MMSCMD"
          secondXDataKey={
            selectedKeys.length > 1 ? selectedKeys[1].key : undefined
          }
          rendexSecondXTick={(value: any) => renderQuarterTick(value, 8)}
        />
      </div>
    </div>
  );

  function getColors(string: string) {
    if (string === "Domestic Consumption") {
      return "#FF0000";
    }
    if (string === "RLNG Consumption") {
      return "#0000FF";
    } else {
      stringToConsistentColor(string);
    }
  }
}
